import Home from './routes/Home.svelte';
import Auth from './routes/Auth.svelte';
import Resetpassword from './routes/Resetpassword.svelte';
import Register from './routes/Register.svelte';
import Setaff from './routes/Setaff.svelte';
import NotFound from './routes/NotFound.svelte';
import Dashboard from './routes/Member/Dashboard.svelte';
import Providerlist from './routes/Member/Providerlist.svelte';
import Gamelist from './routes/Member/Gamelist.svelte';
import Startgame from './routes/Member/Startgame.svelte';
import Playgame from './routes/Member/Playgame.svelte';
import Deposit from './routes/Member/Deposit.svelte';
import Setting from './routes/Member/Setting.svelte';
import Withdraw from './routes/Member/Withdraw.svelte';
import History from './routes/Member/History.svelte';
import Message from './routes/Member/Message.svelte';
import Affiliate from './routes/Affiliate/Affiliate.svelte';
import Downline from './routes/Affiliate/Downline.svelte';
import Report from './routes/Affiliate/Report.svelte';
import AffHistory from './routes/Affiliate/History.svelte';
import Promotion from './routes/Member/Promotion.svelte';
import Promotiondetail from './routes/Member/Promotiondetail.svelte';
import Promotioncode from './routes/Member/Promotioncode.svelte';
import Promotionapply from './routes/Member/Promotionapply.svelte';
import Reward from './routes/Member/Reward.svelte';
import Gpay from './routes/Member/Gpay.svelte';
import Gpayfp from './routes/Member/Gpayfp.svelte';
import EZpay from './routes/Member/EZpay.svelte';
import SPay from './routes/Member/SPay.svelte';
import P2Wpay from './routes/Member/P2Wpay.svelte';
import AZpay from './routes/Member/AZpay.svelte';
import GMPAY24 from './routes/Member/GMPAY24.svelte';
import SETZERO from './routes/Member/SETZEROPAY.svelte';
import XDeposit from './routes/Member/XDeposit.svelte';
import Ranking from './routes/Member/Ranking.svelte';
import Cashback from './routes/Member/Cashback.svelte';
import PwaInstall from './routes/PwaInstall.svelte';
import NewsArticle from './routes/Member/NewsArticle.svelte';

export default {
    '/': Auth,
    '/auth': Auth,
    '/pwa-install': PwaInstall,
    '/resetpassword': Resetpassword,
    '/a/:affid': Setaff,
    '/register/:sid': Register,
    '/register': Register,
    '/dashboard': Dashboard,
    '/provider/:pid/:sid': Providerlist,
    '/gamelist/:gid': Gamelist, 
    // '/gamelist/:sid/:gid': Gamelist, 
    '/startgame/:gid': Startgame, 
    '/playgame': Playgame, 
    '/deposit': XDeposit,
    '/xdeposit': XDeposit,
    '/withdraw': Withdraw,
    '/setting': Setting,
    '/history': History,
    '/message': Message,
    '/affiliate': Affiliate,
    '/affiliate/downline': Downline,
    '/affiliate/report': Report,
    '/affiliate/history': AffHistory,
    '/promotion': Promotion,
    '/promotion/:sid': Promotiondetail,
    '/promotioncode/:sid': Promotioncode,
    '/promotionapply/:sid': Promotionapply,
    '/reward': Reward,
    '/gpay/:txn': Gpay, 
    '/gpayfp/:txn': Gpayfp, 
    '/ezpay/:txn': EZpay, 
    '/spay/:txn': SPay, 
    '/p2w/:txn': P2Wpay,
    '/azpay/:txn': AZpay,
    '/gmpay24/:txn': GMPAY24, 
    '/setzero/:bankid': SETZERO,
    '/ranking': Ranking,
    '/cashback': Cashback,
    '/news/:id': NewsArticle,

    // The catch-all route must always be last
    '*': NotFound
};
